import { render, staticRenderFns } from "./AddEmployees.vue?vue&type=template&id=1c321c1a&"
import script from "./AddEmployees.vue?vue&type=script&lang=ts&"
export * from "./AddEmployees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports